
import { AllInclusiveRounded } from "@material-ui/icons";
import { updateShowFavouriteOption } from "../actions";
import {ADD_ARTICLE, REFRESH_STEAMER_DRIFTER, SETTING_CHANGED, STEAMER_DRIFTER_FILTER_COMPLETED, STEAMER_DRIFTER_FILTER_DRIFTER_MIN, STEAMER_DRIFTER_FILTER_STEAMER_LOW_LIMIT, UPDATE_CONFIRM_BOX_STATUS, UPDATE_SHOW_FAVOURITE_OPTIONS } from "../constants/action-types";
import {UPDATE_TIME_SETTINGS } from "../constants/action-types";
import {UPDATE_TIME_SETTINGS_ONE_BY_ONE } from "../constants/action-types";
import {UPDATE_ALL_COUNTRY_LIST } from "../constants/action-types";
import {UPDATE_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import {ADD_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import {UPDATE_BACK_STAKE_SETTINGS, UPDATE_COMMISSION_SETTINGS, UPDATE_DISPLAY_CONFIRM_NOX, UPDATE_LAY_STAKE_SETTINGS, UPDATE_STAKE_SETTINGS, UPDATE_TOKEN } from "../constants/action-types";
import {REMOVE_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import {UPDATE_CURRENT_RACE_TIME} from "../constants/action-types";
import {UPDATE_T0_SETTINGS} from "../constants/action-types";
import {RUNNERS_ODDS_AT_TIMES} from "../constants/action-types";
import {UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE} from "../constants/action-types";
import {UPDATE_EXACT_TIME_SETTINGS} from "../constants/action-types";
import {UPDATE_IS_EXACT_TIME_SELECTED_ONE_BY_ONE} from "../constants/action-types";
import {IS_REFRESHED} from "../constants/action-types";
import {UPDATE_STEAMER_DRIFTER_SETTINGS} from "../constants/action-types";
import {UPDATE_LOCAL_TIME_OFFSET_TO_GMT} from "../constants/action-types";
import {UPDATE_LOCAL_TIME_ZONE} from "../constants/action-types";
import {UPDATE_LATEST_ODDS_SETTINGS} from "../constants/action-types";
import {SET_CUSTOM_SETTINGS_STATE} from "../constants/action-types";
import {UPDATE_BET_MARKET, UPDATE_AI_RANK_STATS} from "../constants/action-types";
import {STEAMER_DRIFTER_FILTER_FAVOURITE} from "../constants/action-types";
import {STEAMER_DRIFTER_FILTER_DRIFTER_LOW_LIMIT} from "../constants/action-types";
import {STEAMER_DRIFTER_FILTER_DRIFTER_UPPER_LIMIT} from "../constants/action-types";
import {STEAMER_DRIFTER_FILTER_STEAMER_UPPER_LIMIT} from "../constants/action-types";
import {STEAMER_DRIFTER_FILTER_INCLUDE_HARNESS} from "../constants/action-types";

import moment from 'moment';
import momentz from 'moment-timezone';

const intialState = {
  isRefreshed: false,
  settingChangedVersion: 0,
  articles: [],
  latestOddsSettings: {
    tickUntilActualStart: "yes",
    noOfSeconds: "10",
    commision: "5",
    backStake: "0.1",
    layStake: "0.1"
  },
  customSettingsState: {
    displayTicks: true
  },
  currentBets: [],
  clearedBets:[],
  loginToken: "",
  showFavoriteOnly: false,
  t0Settings:{
    optiongb:"exact",
    diffgb:"0",
    exactgb:moment().tz("Etc/GMT"),

    optionanz:"exact",
    diffanz:"0",
    exactanz:moment().tz("Etc/GMT"),

    optionoth:"exact",
    diffoth:"0",
    exactoth:moment().tz("Etc/GMT"),
  },
  timeSettings:{
    t1: "02:00",
    t2: "01:00",
    t3: "00:30",
    t4: "00:15",
    t5: "00:10",
    t6: "00:05",
    t0gb: "00:05",
    t0anz: "00:06",
    t0oth: "00:07"
  },
  exactTimeSettings:{
    t1: "01:30",
    t2: "01:45",
    t3: "02:00",
    t4: "02:30",
    t5: "03:00",
    t6: "04:00",
    t0gb: "00:01",
    t0anz: "00:02",
    t0oth: "00:03"

  },
  isExactTimeSelected:{
    t1: "diff",
    t2: "diff",
    t3: "diff",
    t4: "diff",
    t5: "diff",
    t6: "diff",
    t0gb: "exact",
    t0anz: "exact",
    t0oth: "exact"
  },
  allCountryList:[],
  allCountryList2:{
    UK:"GB",
    IRE:"IE",
    AUS:"AU",
    NZ:"NZ",
    RSA:"ZA",
    HKG:"HK",
    USA:"US",
    SWE:"SE",
    // JPN:"JP",
    DEU:"DE",
    FRA:"FR",
    SGP:"SG"
  },
  filteredCountryList:["GB","IE","AU","NZ","US"],
  fullCountryName:{
    GB:"Great Britain",
    IR:"Iran",
    AU:"Australia",
    FR:"France",
    US:"United States",
    CL:"Chile",
    IE:"Ireland",
    NZ:"New Zealand",
    ZA:"South Africa",
    US:"United States",
    SE:"Sweden",
    // JP:"Japan",
    DE:"Germany",
    FR:"France",
    SG:"Singapore"
  },
  StearmerDrifterSettings:{
    STEAMER_MIN_PRICE:"1.50",
    STEAMER_MAX_PRICE:"10.00",
    DRIFTER_MIN_PRICE:"1.50",
    DRIFTER_MAX_PRICE:"10.00",
    MIN_VOLUME:"5000"
  },
  runnersOddsAtTimes:[],
  currentRaceTime: moment(),
  localTimeOffSetToGmt: 60,
  localTimeZone: "GMT+01:00",
  displayConfirmBox: true,
  confirmedBoxDisplayed: false,
  refreshSteamerDrifter: false,
  betMarket: null,
  aiRankStats: null,
  streamerDrifterFilterSettings:{
    isFav: false,
    isCompleted: false,
    steamerLowerLimit: 0,
    drifterLowerLimit: 0,
    steamerUpperLimit: 100,
    drifterUpperLimit: 100,
    includeHarness: false,
    steamerRange: [0, 100],
    drifterRange: [0, 100]
  }
};


function rootReducer(state = intialState, action){
  if (action.type === SETTING_CHANGED) {
    return Object.assign({}, state, {
      settingChangedVersion: action.payload
    });
  }

  if (action.type === ADD_ARTICLE) {
    return Object.assign({}, state, {
      articles: state.articles.concat(action.payload)
    });
  }
  else if(action.type === UPDATE_TIME_SETTINGS){
    return Object.assign({}, state, {
      timeSettings: action.payload
    });
  }
  else if(action.type === UPDATE_TIME_SETTINGS_ONE_BY_ONE){
    let object = state.timeSettings
    //console.log("FFZFF UPDATE_TIME_SETTINGS_ONE_BY_ONE "+action.payload.id + " value "+action.payload.value);
    if(action.payload.value !== undefined){
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        timeSettings: object
      });
    }

  }
  else if(action.type === UPDATE_EXACT_TIME_SETTINGS){
    return Object.assign({}, state, {
      exactTimeSettings: action.payload
    });
  }
  else if(action.type === UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE){
    let object = state.exactTimeSettings
    //console.log("FFZFF UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE "+action.payload.id + " value "+action.payload.value);
    if(action.payload.value !== undefined){
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        exactTimeSettings: object
      });
    }
  }
  else if(action.type === UPDATE_ALL_COUNTRY_LIST){
    return Object.assign({}, state, {
      allCountryList: action.payload
    });
  }
  else if(action.type === UPDATE_FILTERED_COUNTRY_LIST){
    return Object.assign({}, state, {
      filteredCountryList: action.payload
    });
  }
  else if(action.type === ADD_FILTERED_COUNTRY_LIST){
    return Object.assign({}, state, {
      filteredCountryList: state.filteredCountryList.concat(action.payload)
    });
  }
  else if(action.type === REMOVE_FILTERED_COUNTRY_LIST){
    return Object.assign({}, state, {
      filteredCountryList: state.filteredCountryList.filter(data => data!=action.payload)
    });
  }
  else if(action.type === UPDATE_CURRENT_RACE_TIME){
    return Object.assign({}, state, {
      currentRaceTime: action.payload
    });
  }
  else if(action.type === UPDATE_T0_SETTINGS){
    let object = state.t0Settings
    //("FFZFF "+action.payload.option + " value "+action.payload.value);
    if(action.payload.value !== undefined){
    object[action.payload.id] = action.payload.value
    return Object.assign({}, state, {
      t0Settings: object
    });
  }
  }
  else if(action.type === RUNNERS_ODDS_AT_TIMES){
    return Object.assign({}, state, {
      runnersOddsAtTimes: action.payload
    });
  }
  else if(action.type === IS_REFRESHED){
    return Object.assign({}, state, {
      isRefreshed: action.payload
    });
  }
  else if(action.type === UPDATE_IS_EXACT_TIME_SELECTED_ONE_BY_ONE){
    let object = state.isExactTimeSelected
    //console.log("IS EXACT TIME SELECTED: "+action.payload.id + " value "+action.payload.value);
    if(action.payload.value !== undefined){
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        isExactTimeSelected: object
      });
    }
  }
  else if(action.type === UPDATE_STEAMER_DRIFTER_SETTINGS){
    let object = state.StearmerDrifterSettings
    if(action.payload.value !== undefined){
    //console.log("Steamer Drifter Settings : "+action.payload.id + " value "+action.payload.value);
    object[action.payload.id] = action.payload.value
    return Object.assign({}, state, {
      StearmerDrifterSettings: object
    });
  }
  }
  else if(action.type === UPDATE_LOCAL_TIME_OFFSET_TO_GMT){
    //console.log("UPDATE_LATEST_ODDS_SETTINGS: "+ action.payload.id + " value "+action.payload.value);
    return Object.assign({}, state, {
      localTimeOffSetToGmt: action.payload
    });
  }
  else if(action.type === SET_CUSTOM_SETTINGS_STATE){
    //console.log("SET_CUSTOM_SETTINGS_STATE: value "+action.payload);
    //console.log(action.payload)
    return Object.assign({}, state, {
      customSettingsState: action.payload
    });
  }
  else if(action.type === UPDATE_LOCAL_TIME_ZONE){
    return Object.assign({}, state, {
      localTimeZone: action.payload
    });
  }
  else if(action.type === UPDATE_BET_MARKET){
    return Object.assign({}, state, {
      betMarket: action.payload
    });
  }
  else if(action.type === UPDATE_AI_RANK_STATS){
    return Object.assign({}, state, {
      aiRankStats: action.payload
    });
  }
  else if(action.type === UPDATE_LATEST_ODDS_SETTINGS){
    let object = state.latestOddsSettings
    if(action.payload.value !== undefined){
      //console.log("UPDATE_LATEST_ODDS_SETTINGS: "+ action.payload.id + " value "+action.payload.value);
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        latestOddsSettings: object
      });
    }
  }
  else if(action.type === UPDATE_COMMISSION_SETTINGS
    ||action.type === UPDATE_BACK_STAKE_SETTINGS
    || action.type === UPDATE_LAY_STAKE_SETTINGS){
    let object = state.latestOddsSettings
    if(action.payload.value !== undefined){
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        latestOddsSettings: object
      });
    }
  }
  else if(action.type === UPDATE_TOKEN){
    return Object.assign({}, state, {
        loginToken: action.payload
      });
    }
    else if(action.type === UPDATE_DISPLAY_CONFIRM_NOX){
      return Object.assign({}, state, {
          displayConfirmBox: action.payload
        });
      }  
        else if(action.type === REFRESH_STEAMER_DRIFTER){
      return Object.assign({}, state, {
          refreshSteamerDrifter: action.payload
        });
      }  
     else if(action.type === UPDATE_SHOW_FAVOURITE_OPTIONS){
      return Object.assign({}, state, {
         showFavoriteOnly : action.payload
        });
      }    
  else if (action.type === UPDATE_CONFIRM_BOX_STATUS) {
    return Object.assign({}, state, {
      confirmedBoxDisplayed: action.payload
    });
  }
  else if (action.type === STEAMER_DRIFTER_FILTER_FAVOURITE) {
    let object = state.streamerDrifterFilterSettings
    object['isFav'] = action.payload
    return Object.assign({}, state, {
      streamerDrifterFilterSettings: object
    });
  } 
  else if (action.type === STEAMER_DRIFTER_FILTER_INCLUDE_HARNESS) {
    let object = state.streamerDrifterFilterSettings
    object['includeHarness'] = action.payload
    return Object.assign({}, state, {
      streamerDrifterFilterSettings: object
    });
  } 
   else if (action.type === STEAMER_DRIFTER_FILTER_STEAMER_LOW_LIMIT) {
    let object = state.streamerDrifterFilterSettings
    object['steamerLowerLimit'] = action.payload
    return Object.assign({}, state, {
      streamerDrifterFilterSettings: object
    });
  } 
   else if (action.type === STEAMER_DRIFTER_FILTER_DRIFTER_LOW_LIMIT) {
    let object = state.streamerDrifterFilterSettings
    object['drifterLowerLimit'] = action.payload
    return Object.assign({}, state, {
      streamerDrifterFilterSettings: object
    });
  } 
  else if (action.type === STEAMER_DRIFTER_FILTER_STEAMER_UPPER_LIMIT) {
    let object = state.streamerDrifterFilterSettings
    object['steamerUpperLimit'] = action.payload
    return Object.assign({}, state, {
      streamerDrifterFilterSettings: object
    });
  } 
   else if (action.type === STEAMER_DRIFTER_FILTER_DRIFTER_UPPER_LIMIT) {
    let object = state.streamerDrifterFilterSettings
    object['drifterUpperLimit'] = action.payload
    return Object.assign({}, state, {
      streamerDrifterFilterSettings: object
    });
  } 
   else if (action.type === STEAMER_DRIFTER_FILTER_COMPLETED) {
    let object = state.streamerDrifterFilterSettings
    object['isCompleted'] = action.payload
    return Object.assign({}, state, {
      streamerDrifterFilterSettings: object
    });
  } 
   else if (action.type === STEAMER_DRIFTER_FILTER_COMPLETED) {
    let object = state.streamerDrifterFilterSettings
    object['isCompleted'] = action.payload
    return Object.assign({}, state, {
      streamerDrifterFilterSettings: object
    });
  } 
  
  return state;
}

export default rootReducer
